import type { CustomCell, CustomRenderer } from '@glideapps/glide-data-grid'
import { GridCellKind } from '@glideapps/glide-data-grid'
import type { Theme } from '@mui/material/styles'

export type DotStatus = 'success' | 'warning' | 'error' | 'default'

export const getDotColor = (status: DotStatus, theme: Theme): string => {
  switch (status) {
    case 'success':
      return theme.palette.success.main
    case 'warning':
      return theme.palette.warning.main
    case 'error':
      return theme.palette.error.main
    default:
      return theme.palette.grey[500]
  }
}

interface StatusCellProps {
  readonly status: DotStatus
  readonly value: string
  readonly kind: 'status-cell'
}
export type StatusCell = CustomCell<StatusCellProps>

export const statusCellRenderer = (muiTheme: Theme): CustomRenderer<StatusCell> => ({
  draw: (args, cell) => {
    const { rect, ctx, theme } = args
    const { x, y, height } = rect

    ctx.fillStyle = theme.textDark
    ctx.fillText(cell.data.value, x + 30, y + height / 2)

    const circle = new Path2D()

    circle.arc(x + 15, y + height / 2, 4, 0, 2 * Math.PI)

    ctx.fillStyle = getDotColor(cell.data.status, muiTheme)
    ctx.fill(circle)

    return true
  },
  isMatch: (c): c is StatusCell => (c.data as StatusCellProps).kind === 'status-cell',
  kind: GridCellKind.Custom,
})
